export enum PackStatus_Enum
{
    Undefined,

    Incomplete,

    Complete,

    Verified,

    NotRequired
}